import { lazy } from "react";
import { Navigate } from "react-router-dom";
import ProtectedRoute from "../guards/ProtectedRoute";
import { LAYOUT_IDENTIFIERS, MODULE_PATHS } from "../../utils/moduleConfig";

const MainLayout = lazy(() => import("../../layouts/MainLayout/MainLayout"));
const AssetOverview = lazy(() =>
  import("../../Modules/HomeManager/Assets/Page/AssetOverviewPage")
);
const AssetManager = lazy(() =>
  import("../../Modules/HomeManager/Assets/Page/AssetPage")
);
const CalendarPage = lazy(() =>
  import("../../Modules/HomeManager/Events/Page/CalendarPage")
);
const Homemanager = lazy(() => import("../../Modules/HomeManager/HomeManager"));
const MealOverview = lazy(() =>
  import("../../Modules/HomeManager/MealPlanning/Page/MealOverview")
);
const MealPlanner = lazy(() =>
  import("../../Modules/HomeManager/MealPlanning/Page/MealPlanPage")
);
const RecipeCreateEdit = lazy(() =>
  import("../../Modules/HomeManager/MealPlanning/Page/RecipeCreateEdit")
);
const RecipeDetail = lazy(() =>
  import("../../Modules/HomeManager/MealPlanning/Page/RecipeDetail")
);
const TaskChores = lazy(() =>
  import("../../Modules/HomeManager/TaskChores/Page/TaskChoresPage")
);

// ProtectedRoute on the layout element guards every child automatically.
// Child-level ProtectedRoute wrappers are removed — they were redundant
// and caused a loading-flash on every page navigation.
const homeManagerRoutes = {
  path: MODULE_PATHS.homeManager,
  element: (
    <ProtectedRoute>
      <MainLayout identifier={LAYOUT_IDENTIFIERS.homeManager} />
    </ProtectedRoute>
  ),
  children: [
    {
      index: true,
      element: <Navigate to="dashboard" replace />,
    },
    { path: "dashboard",                          element: <Homemanager /> },
    { path: "task-chores",                        element: <TaskChores /> },
    { path: "assets",                             element: <AssetManager /> },
    { path: "assets/:assetId",                    element: <AssetOverview /> },
    { path: "calendar",                           element: <CalendarPage /> },
    { path: "meal-planning",                      element: <MealPlanner /> },
    { path: "meal-planning/recipe/:recipeId",     element: <RecipeDetail /> },
    { path: "meal-planning/recipe/create",        element: <RecipeCreateEdit /> },
    { path: "meal-planning/recipe/:recipeId/edit",element: <RecipeCreateEdit /> },
    { path: "meal-planning/meal-overview",        element: <MealOverview /> },
  ],
};

export default homeManagerRoutes;
